import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import Index from '../../../../questionsSearch/index';
import CastleQuestionsSearch from '../../../../questionsSearch/components/castleQuestionsSearch/main';
import CastleReadingSets from '../../../../questionsSearch/pages/castleReadingSets/pages/castleReadingSets';
import MathSkills from '../../../../questionsSearch/components/mathSkills/mathSkills';
import DBQSets from '../../../../questionsSearch/components/dbqSets/dbqSets';
import { AssignmentProvider } from '../../../../assignments/context';
import MathSkillQuestions from '../../../../questionsSearch/components/mathSkills/MathSkillQuestions';
import { DataProvider } from '../../../../assignments/DataContext';

const questionSearchRoute = () => {
  return (
    <div>
      <AssignmentProvider>
        <Routes>
          <Route path="/" element={<DataProvider><Index /></DataProvider>}>
            <Route index element={<Navigate to="castle_questions" />} />
            <Route path=":from?/:qSetId?/castle_questions/*" element={<CastleQuestionsSearch />} />
            <Route path=":from?/:qSetId?/castle_reading_sets" element={<CastleReadingSets />} />
            <Route path=":from?/:qSetId?/math_skills" element={<MathSkills />} />
            <Route path=":from?/:qSetId?/math_skills/math_skills_questions" element={<MathSkillQuestions />} />
            <Route path=":from?/:qSetId?/dbqSets" element={<DBQSets />} />
          </Route>
        </Routes>
      </AssignmentProvider>
    </div>
  );
};

export default questionSearchRoute;